import { TableHeader, Pagination, Search } from '../Table';
import React, { useState, useEffect, useMemo } from 'react';
import Loader from '../include/Loader';
import Menu from '../include/Menu';
import Footer from '../include/Footer';
import { Dropdown, Table } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import HistoryIcon from '@material-ui/icons/History';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../include/Spinner';
import { handleLogout } from '../../../config';

export default function ClaimRequestList() {
  const location = useLocation();
  const navigate = useNavigate();
  const [entity, setEntity] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState({ field: '', order: '' });
  const [limit, setlimit] = useState(10);
  const [Loading, setLoading] = useState(true);

  const userHeader = [
    {
      name: 'Sr. No.',
      field: 'id',
      sortable: false,
    },
    {
      name: 'Customer',
      // field: "",
      sortable: false,
    },
    {
      name: 'Customer Email',
      // field: "",
      sortable: false,
    },
    {
      name: 'Customer PhoneNo',
      // field: "",
      sortable: false,
    },
    {
      name: 'Item',
      // field: "",
      sortable: false,
    },
    {
      name: 'Driver Name',
      // field: "",
      sortable: false,
    },
    {
      name: 'Driver Email',
      // field: "to",
      sortable: false,
    },

    {
      name: 'Customer\'s Query',
      sortable: false,
    },
    {
      name: 'Driver\'s Conformation',
      sortable: false,
    },
    {
      name: 'Status',
      sortable: false,
    },
    {
      name: 'Action',
      sortable: false,
    },
  ];

  const commentsData = useMemo(() => {
    let computedComments = entity;

    if (search) {

      computedComments = computedComments.filter(
        (claims) =>
          claims?.claimant_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.email?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.phone_number?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.item_des?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.driver_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.driver_email?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.customer_message?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.driver_message?.toLowerCase()?.includes(search?.toLowerCase()) ||
          claims?.status == 0 && "declined".includes(search?.toLowerCase()) ||
          claims?.status == 1 && "pending".includes(search?.toLowerCase()) ||
          claims?.status == 2 && "accepted".includes(search?.toLowerCase())


      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, sorting, limit, entity]);

  useEffect(() => {
    getDriverList();
    document.getElementById('page-loader').style.display = 'none';
    var element = document.getElementById('page-container');
    element.classList.add('show');
  }, []);

  const getDriverList = () => {
    const myurl = 'https://api.teleportanything.com/api/admin/claim-request-list';
    //const myurl = 'http://localhost:3000/api/admin/claim-request-list';
    var bodyFormData = new URLSearchParams();
    bodyFormData.append('status', filterData.status);
    axios({
      method: 'post',
      url: myurl,
      data: bodyFormData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}`
      },
    })
      .then(async (response) => {
        setDisable(false);
        if (response?.data?.sucecess) {
          let data = await response?.data?.data?.map((e, i) => {
            return { ...e, sr_no: i + 1 };
          });
          setEntity(data);
        } else {
          if (response?.data?.code === 401) {
            handleLogout(navigate);
            return;
          }
          toast.error('Something went wrong');
        }
        setLoading(false)
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.data?.code === 401) {
          handleLogout(navigate);
          return;
        }
        toast.error('Something went wrong');
        console.error("Errors", error);
        setLoading(false)
      });
  };


  const actionHandler = (e, id, item_description, status) => {
    e.target.blur();
    let msg;
    if (status == 0)
      msg = "Are you sure you want to decline the claim request?";
    else if (status == 2)
      msg = "Are you sure you want to accept the claim request?";
    if (window.confirm(msg)) {

      const myurl = "https://api.teleportanything.com/api/admin/accept-claim-request";
      //const myurl = "http://localhost:3000/api/admin/accept-claim-request";
      var bodyFormData = new URLSearchParams();
      bodyFormData.append('id', id);
      bodyFormData.append('status', status);
      bodyFormData.append('item_description', item_description);
      setLoading(true)

      axios({
        method: "post",
        url: myurl,
        data: bodyFormData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${localStorage.getItem('DM_Admin_TOKEN')}`
        },
      }).then((response) => {
        if (response.data.sucecess == true) {
          getDriverList();
          toast.success(status == 2 ? "Request accepted successfully" : "Request declined successfully");
        }
        setLoading(false)
      }).catch((error) => {
        if (error?.response?.status === 401 || error?.response?.data?.code === 401) {
          handleLogout(navigate);
          return;
        }
        console.error("Errors", error);
        setLoading(false)
      })
    }
  }

  const [disable, setDisable] = useState(false);
  const [filterData, setFilterData] = useState({
    status: ''
  });
  const handleInput = (e) => {
    ;
    const basicData = { ...filterData };
    basicData[e.target.name] = e.target.value;
    setFilterData(basicData);
  }
  const handleSearch = (e) => {
    setDisable(true);
    getDriverList();
  }

  const handleReset = () => {
    window.location.reload();
  }

  return (
    <>
      <Loader />

      <div
        id="page-container"
        className="fade page-sidebar-fixed page-header-fixed"
      >
        <Menu />

        <div id="content" className="content">
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item basePath ">
              <a href="javascript:;">Home</a>
            </li>
            <li className="breadcrumb-item active currentPath">
              Claim Request Management
            </li>
          </ol>
          <h1 className="page-header">Claim Request Management</h1>

          {/* <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '20px',
            }}
          >
            <div className="row w-100">
                <div className="col-12 text-center">
                <h6 style={{textAlign:"left"}}>Filter For Jobs Management:</h6>
                  <div className="row">
                   
                      <div className="col-md-3 form-group">
                        <select className="form-control" name="status" onChange={handleInput} value={filterData.status}>
                                <option value="">Select Status</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                                <option value="2">Draft</option>
                                <option value="3">Completed</option>
                            </select>
                      </div>

                      <div className="col-md-3" style={{ textAlign: "left"}}>
                        <button type='button' className='btn btn-md btn-primary m-t-2' style={{ cursor:"pointer" }} disabled={disable} onClick={handleSearch} >{disable ? 'Processing...' : 'Search'}</button>
                        <button type='button' className='btn btn-md btn-primary m-t-2' style={{ cursor:"pointer", marginLeft: "10px" }} onClick={handleReset} >Reset</button>
                      </div>
                  </div>
                </div>
              </div>
            </div> */}


          <br />

          {!Loading ? (
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '20px',
                marginTop: '10px',
              }}
            >
              <div className="row w-100">
                <div className="mb-3 col-12 text-center">
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-sm-6 col-12 mb-3">
                      <div className="ml-0">
                        <div className="d-flex">
                          <h5 className="mt-2 mr-1">Search: </h5>
                          <Search
                            onSearch={(value) => {
                              setSearch(value);
                              setCurrentPage(1);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-sm-6 col-12 d-flex justify-content-end mb-3">
                      <div
                        style={{
                          color: 'black',
                          fontSize: '12px',
                          fontWeight: '300',
                          paddingTop: '0px',
                          paddingBottom: '0px',
                        }}
                        className="align-self-center"
                      >
                        <b>Rows per page :&nbsp;</b>
                      </div>
                      <div className="align-self-center">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="none"
                            id="dropdown-basic"
                            style={{
                              cursor: 'auto',
                              backgroundColor: 'white',
                              borderColor: '#d5dbe0',
                              paddingBottom: '3px',
                              paddingTop: '3px',
                            }}
                          >
                            {limit}&nbsp;<i className="fa fa-caret-down"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {limit !== 10 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(10);
                                  }}
                                >
                                  10
                                </Dropdown.Item>
                              </>
                            ) : null}

                            {limit !== 20 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(20);
                                  }}
                                >
                                  20
                                </Dropdown.Item>
                              </>
                            ) : null}

                            {limit !== 30 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(30);
                                  }}
                                >
                                  30
                                </Dropdown.Item>
                              </>
                            ) : null}

                            {limit !== 50 ? (
                              <>
                                <Dropdown.Item
                                  onClick={() => {
                                    setlimit(50);
                                  }}
                                >
                                  50
                                </Dropdown.Item>
                              </>
                            ) : null}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-12">
                      <div className="table-responsive">
                        <Table striped bordered hover>
                          <thead>
                            <TableHeader
                              headers={userHeader}
                              onSorting={(field, order) =>
                                setSorting({ field, order })
                              }
                            />
                          </thead>
                          <tbody>
                            {commentsData.map((e, i) => (
                              <tr>
                                <>
                                  <td>{e?.sr_no}</td>
                                  <td>{e?.claimant_name}</td>
                                  <td>{e?.email}</td>
                                  <td>{e?.phone_number}</td>
                                  <td>{e?.item_des}</td>
                                  <td>{e?.driver_name}</td>
                                  <td>{e?.driver_email}</td>
                                  <td>{e?.customer_message}</td>
                                  <td>{e?.driver_message}</td>
                                  <td>{e.status == 0 ?
                                    <span class="text-danger">Declined</span>
                                    : (e.status == 1 ?
                                      <span class="text-warning">Pending</span>
                                      : <span class="text-success ">Accepted</span>
                                    )}
                                  </td>
                                  <td >
                                    {e.status == 1 ?
                                      <div style={{ display: "flex", gap: "3px" }}>
                                        <button className="btn btn-success btn-sm" onClick={(evt) => actionHandler(evt, e?.claim_id, e?.item_des, 2)}>Yes</button>
                                        <button className='btn btn-danger btn-sm' onClick={(evt) => actionHandler(evt, e?.claim_id, e?.item_des, 0)}>No</button>
                                      </div>
                                      : "-"
                                    }
                                  </td>
                                </>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        {commentsData.length == 0 ? (
                          <div className="row d-flex justify-content-center w-100">
                            <div className="mx-auto  d-flex justify-content-center w-100">
                              <img
                                src="./assets/img/icon/no-location.png"
                                className="form-img__img-preview"
                                style={{ width: '100px', height: '100px' }}
                                alt=""

                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div
                    className="mt-2 d-flex justify-content-sm-center justify-content-xs-center justify-content-lg-end"
                    style={{
                      overflowX: 'auto',
                    }}
                  >
                    <Pagination
                      total={totalItems}
                      itemsPerPage={limit}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Spinner />
          )}
        </div>

        <Footer />
      </div>
    </>
  );
}
